var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['audio-icon-container', { small: _vm.size === 'small' }]},[_c('div',{staticClass:"audio-level-container"},[_c('div',{staticClass:"audio-level",style:(_vm.audioLevelStyle)})]),_c('svg-icon',{staticClass:"audio-icon",attrs:{"icon":_vm.icon}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }